import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BookingPage from './pages/BookingPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminBookingsPage from './pages/AdminBookingsPage';
import SocialAdsPage from './pages/SocialAdsPage';
import GenomicsCoverPage from './pages/GenomicsCoverPage';
import FarmerBreederCoverPage from './pages/FarmerBreederCoverPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AdminPreviewPanel from './components/AdminPreviewPanel';

import { Toaster } from './components/ui/sonner';
import { initGA4, trackPageView } from './lib/analytics';
import './App.css';

// Fires a page_view on every client-side route change (admin pages excluded)
const AnalyticsRouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Skip tracking for admin / internal tooling routes
    if (location.pathname.startsWith('/admin-bookings')) return;
    // Track pathname only — strip query strings to keep top-pages aggregate clean
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
};

function App() {
  useEffect(() => { initGA4(); }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsRouteTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/admin-bookings" element={<AdminBookingsPage />} />
          <Route path="/social-ads" element={<SocialAdsPage />} />
          <Route path="/genomics-cover" element={<GenomicsCoverPage />} />
          <Route path="/farmer-cover" element={<FarmerBreederCoverPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
        <AdminPreviewPanel />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
